export default {
  title: 'Správa o kvalite',
};
